module.exports = __webpack_public_path__ + "img/imgVirtualTryOn04.87f4f475.png";